import React, { ReactElement, ReactNode } from 'react'

interface TermsPrivacyLinkProps {
  onClick: () => void
  children: ReactNode
  linkType?: string
}

const TermsPrivacyLink = ({ onClick, children, linkType }: TermsPrivacyLinkProps): ReactElement => {
  const handleKeyDown = (event: React.KeyboardEvent): void => {
    /* istanbul ignore else */
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onClick()
    }
  }

  return (
    <span
      className="terms-privacy__link"
      tabIndex={0}
      role="button"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      data-testid={linkType ? `${linkType}-link` : ''}
    >
      {children}
    </span>
  )
}

export default TermsPrivacyLink
